export default "__VITE_ASSET__DZKnsvJF__"